module.exports = __webpack_public_path__ + "static/img/service_icon_4.10a48b90.png";